module.exports = __webpack_public_path__ + "img/vqvtest.c2abfb76.png";